import React, { FC } from 'react';

import { formatDate } from '@buyside/util/dateHelper';

import styles from '@buyside/components/presentation/JobVaultShowPage/JobVaultShowHeader/jobVaultShowHeaderStyles.scss';

const JobVaultShowHeader: FC<{ title: string; postedAt: string }> = ({ title, postedAt }) => (
  <div className={styles.headerInfo}>
    <div className={styles.headerTitle}>{title}</div>
    <div className={styles.headerPostedAt}>
      <strong>Posted: </strong>
      {formatDate(postedAt)}
    </div>
  </div>
);

export default JobVaultShowHeader;
